<template>
  <vs-row v-if="form">
    <vs-col vs-w="12">
      <div class="vx-card show-azienda" ref="card">
        <div class="vx-card__header">
          <vs-col vs-type="flex" vs-justify="space-between" vs-align="center" vs-w="12" vs-lg="12" vs-sm="12" vs-xs="12">
            <h3 v-if="form"> {{ ['TIROCINIO CONFERMATO: ',form.azienda.ragione_sociale,].join("") }}</h3>
            <feather-icon v-if="this.controller == 'tirocinio'" icon="XIcon" @click="closeSidebar" class="cursor-pointer c-primary"></feather-icon>
          </vs-col>
          <vs-row class="sidebar-header-row p-1 mt-4" vs-justify="flex-start">
            <vs-col vs-type="flex" vs-justify="right" vs-align="center" vs-w="2">Stato attuale:</vs-col>
            <vs-col vs-w="10">
              <ul class="breadcrumbs-two ">
                <li v-for="(stato) in lastStati()" :key="stato.id"
                v-bind:class="{'current': stato.stato == form.stato ? true : false,
                'default': true,
                'p-0': true}">
                  <vs-row vs-align="center">
                   <vx-tooltip :text="$tir.label_of(stato.stato) + ': ' + $tariffe.formatDateNew(stato.data)" position="left" style="width:min-content;">
                     <vs-button class="no-pointer-event" radius color="black" type="flat" icon-pack="feather" :icon="$tir.icon_of(stato.stato)" />
                   </vx-tooltip>
                   <small v-if="stato.stato == form.stato"> {{[$tir.label_of(stato.stato),':',$tariffe.formatDateNew(stato.data)].join(' ')}} </small>
                 </vs-row>
                </li>
              </ul>
            </vs-col>
          </vs-row>
        </div>
        <vs-divider />
        <div class="vx-card__body">
          <vs-row class="mt-10">
            <vs-col class="md:w-3/12 w-full mb-3">
              <span class="font-medium text-lg leading-none">Modulo confermato</span>
            </vs-col>
            <vs-divider />
            <vs-col class="mt-5 mb-5">
              <h5 class="mb-2">I dati sono esatti e completi</h5>
            </vs-col>
          </vs-row>
        </div>
        <div class="vx-card__footer">
          <vs-row vs-type="flex" vs-justify="space-between">
            <vs-col class="mb-5 mt-5" vs-type="flex" vs-justify="left" vs-align="center" vs-w="4">
              <vs-button @click="generateModulo" color="success">Scarica Modulo</vs-button>
            </vs-col>
            <vs-col class="mb-5 mt-5" vs-type="flex" vs-justify="left" vs-align="center" vs-w="4">
              <vs-button @click="generateAutocertificazione">Scarica Condizioni Generali</vs-button>
            </vs-col>
          </vs-row>
        </div>
      </div>
      <vx-card>
        <vs-tabs :alignment="fixedORcenter">
          <vs-tab label="Azienda" icon-pack="feather" icon="icon-grid">
            <StepAzienda :form="form" :is_readonly="true"/>
          </vs-tab>
          <vs-tab label="Tirocinio" icon-pack="feather" icon="icon-shield">
            <StepTirocinio :form="form" :is_readonly="true"/>
          </vs-tab>
          <vs-tab label="Tutor" icon-pack="feather" icon="icon-user-check">
            <StepTutor :form="form" :is_readonly="true"/>
          </vs-tab>
          <vs-tab label="Tirocinante" icon-pack="feather" icon="icon-github">
            <StepTirocinante :form="form" :is_readonly="true"/>
          </vs-tab>
          <vs-tab label="Documentazione" icon-pack="feather" icon="icon-list">
            <StepDocumentazione :form="form" :is_readonly="true"/>
          </vs-tab>
          <vs-tab label="Privacy" icon-pack="feather" icon="icon-eye-off">
            <StepPrivacy :form="form" :is_readonly="true"/>
          </vs-tab>
          <vs-tab v-if="form && form.csv_denom && is_readonly" label="Dati importati" icon-pack="feather" icon="icon-upload-cloud">
            <StepCSV :form="form" :is_readonly="true"/>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </vs-col>
  </vs-row>
</template>

<script>
import Vue from 'vue';
import axios from 'axios'
import FormWizard from '@/components/vue-form-wizard/FormWizard.vue'
import StepAzienda from './modulo/Azienda.vue'
import StepTirocinio from './modulo/Tirocinio.vue'
import StepTutor from './modulo/Tutor.vue'
import StepPrivacy from './modulo/Privacy.vue'
import StepTirocinante from './modulo/Tirocinante.vue'
import StepDocumentazione from './modulo/Documentazione.vue'
import TabContent from '@/components/vue-form-wizard/TabContent.vue'
import StepCSV from './modulo/CSV.vue'

export default {
  props: ['from_token', 'readonly'],
  components: {
    FormWizard,
    TabContent,
    StepAzienda,
    StepTirocinio,
    StepTutor,
    StepDocumentazione,
    StepTirocinante,
    StepPrivacy,
    StepCSV,
  },
  data () {
    return {
      form: null,
      uffici: [],
    }
  },
  created() {
    this.refresh()
    this.getUffici()
  },
  computed: {
    fixedORcenter() {
      if (this.view_size > 800) return 'fixed'
      return 'center'
    },
    controller () {
      return 'modulo-tirocinio'
    },
    is_readonly() {
      return true
    },
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    refresh() {
      this.is_loading = true
      let params = {
        token: this.$route.params.token,
      }
      this.$http.get(this.controller+'/token', { params }).then(res => {

        if (res.data && res.data.id) {
          this.form = Object.assign({},res.data)
        }
        this.form['privacy_b1'] = this.form.azienda.privacy_b1
        this.form['privacy_b2'] = this.form.azienda.privacy_b2
        this.form['privacy_b3'] = this.form.azienda.privacy_b3
        this.form['privacy_b4'] = this.form.azienda.privacy_b4
        this.form['privacy_b5'] = this.form.azienda.privacy_b5

        let twoweeks = 60 * 60 * 1000 * 24 * 7 * 2 // 60mins * 60*secs * 1000millisec * 1day(hour) * 7days * 2weeks
        let d = new Date(this.form.data_inserimento)
        if (( (new Date) - d ) > twoweeks && this.controller != 'tirocinio') {
          this.scaduto = true
          this.readonly = true
        }
      }).finally(res => {
        this.is_loading = false
      })
    },
    lastStati() {
      let response = []
      let history = this.form.stato_history

      history.forEach( s => {
        let x = response.find(r => {return r.stato == s.stato})
        if (!x) response.push(s)
      });

      return response
    },
    lastSaved(stato) {
      return _.reverse(this.form.stato_history).find(x => x.stato == stato)
    },
    generateAutocertificazione() {
      this.activeLoading = true
      this.$vs.loading({
        type:'radius',
      })
      let uffici_string = ''
      if (this.form['azienda']['codice_ufficio'] && this.form['azienda']['codice_ufficio'][0] == '4') {
        uffici_string = this.uffici.find( e => e.codice == this.form['azienda']['codice_ufficio']).descrizione
      } else {
        uffici_string = this.form['azienda']['codice_ufficio']
      }
      let p_to_print = this.$tir.generatePDFtirocinio(this.form,uffici_string)

      let url = '/modulo-tirocinio/generate_autocertificazione'
      axios.post(process.env.VUE_APP_BACKEND_API+url, {
        object: p_to_print,
      },{
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data], {type:'application/octet-stream'}));
        const link = document.createElement('a');
        link.href = url
        this.$vs.loading.close()
        link.setAttribute('download', response.headers['x-file-name']);
        document.body.appendChild(link);
        link.click();
      }).catch(e => {
        console.log(e)
        this.$vs.loading.close()
      })
    },
    generateModulo() {
      this.activeLoading = true
      this.$vs.loading({
        type:'radius',
      })
      let uffici_string = ''
      if (this.form['azienda']['codice_ufficio'] && this.form['azienda']['codice_ufficio'][0] == '4') {
        uffici_string = this.uffici.find( e => e.codice == this.form['azienda']['codice_ufficio']).descrizione
      } else {
        uffici_string = this.form['azienda']['codice_ufficio']
      }
      let p_to_print = this.$tir.generatePDFtirocinio(this.form,uffici_string)

      let url = '/modulo-tirocinio/generate_file'
      axios.post(process.env.VUE_APP_BACKEND_API+url, {
        object: p_to_print,
      },{
        headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
        withCredentials: true,
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data], {type:'application/octet-stream'}));
        const link = document.createElement('a');
        link.href = url
        this.$vs.loading.close()
        link.setAttribute('download', response.headers['x-file-name']);
        document.body.appendChild(link);
        link.click();
      }).catch(e => {
        console.log(e)
        this.$vs.loading.close()
      })
    },
    getUffici() {
      axios.get(process.env.VUE_APP_BACKEND_API+'/modulo-tirocinio/get_uffici',
                {headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
                withCredentials: true,
      }).then(response => {
                this.uffici = response.data
      }).catch(e => console.log(e))
    },
  },

}
</script>
